import { render, staticRenderFns } from "./DeploymentCoOwnersForm.vue?vue&type=template&id=09b56745&"
import script from "./DeploymentCoOwnersForm.vue?vue&type=script&lang=js&"
export * from "./DeploymentCoOwnersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports